// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6979) return "static/chunks/6979-5e418d3bcdc344fd.js";
	if (chunkId === 563) return "static/chunks/563-f01327fdecfde41a.js";
	if (chunkId === 6589) return "static/chunks/6589-3c102e1e56de9dce.js";
	if (chunkId === 7942) return "static/chunks/7942-abc9bbdd829d1468.js";
	if (chunkId === 1868) return "static/chunks/1868-fb0116753b31dfee.js";
	if (chunkId === 10) return "static/chunks/10-03cd0152e52fd1d1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"6baa2c55bddc8670","754":"cd8402d408c2a972","1053":"c3939c6fe6c9a262","1822":"c17a5c787734a2ef","1853":"04fe6002fe4f1a6a","2661":"1447bab42379f3d8","4980":"716468a7a5e13ada","6182":"4c91381a0fbf945c","6540":"0ced24aa3c42e652","8406":"b00e855e0abe3432","8968":"7939d8f4eba392f6","9760":"57887bcabccef4cc"}[chunkId] + ".js";
};